import { ISettingValidate } from './SubscriberData.d'

const specialCharactersValidation: RegExp = /^[a-zA-ZäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ\d\s]+$/
const numbersValidation: RegExp = /\d/
const emailValidation: RegExp = /^[\w-\.]+@([\w-]+\.)+[a-zA-Z]{2,3}$/
const onlyNumbers: RegExp = /^[0-9]*$/
const emailErrorMessage: string = 'El formato del email no es válido'

export const settingValidate: ISettingValidate = {
  name: {
    required: 'El nombre es requerido',
    validate: {
      specialCharacters: (value: string) => {
        const validation: boolean = specialCharactersValidation.test(value)
        return validation || 'El nombre no debe tener caracteres especiales, ejemplo: ¿¡<{[?!>]'
      },
      numbers: (value: string) => {
        const validation: boolean = numbersValidation.test(value)
        return !validation || 'El nombre no debe contener números'
      },
      doublespace: (value: string) => {
        const validation: boolean = value.includes('  ')
        return !validation || 'El nombre no debe tener más de un espacio entre palabras'
      },
    },
    maxLength: {
      value: 50,
      message: 'El nombre no debe tener más de 50 caracteres',
    },
  },
  surname: {
    required: 'El apellido es requerido',
    validate: {
      specialCharacters: (value: string) => {
        const validation: boolean = specialCharactersValidation.test(value)
        return validation || 'El apellido no debe tener caracteres especiales, ejemplo: ¿¡<{[?!>]'
      },
      numbers: (value: string) => {
        const validation: boolean = numbersValidation.test(value)
        return !validation || 'El apellido no debe contener números'
      },
      doublespace: (value: string) => {
        const validation: boolean = value.includes('  ')
        return !validation || 'El apellido no debe tener más de un espacio entre palabras'
      },
    },
    maxLength: {
      value: 50,
      message: 'El apellido no debe tener más de 50 caracteres'
    },
  },
  email: {
    required: 'El email es requerido',
    validate: {
      emailStandar: (value: string) => {
        const validation: boolean = emailValidation.test(value)
        return validation || emailErrorMessage
      },
      doubleAt: (value: string) => {
        const firstAt: number = value.indexOf('@')
        const lastAt: number = value.lastIndexOf('@')
        return firstAt === lastAt || emailErrorMessage
      },
    },
    maxLength: {
      value: 80,
      message: emailErrorMessage,
    },
  },
  phoneNumber: {
    required: 'El número es requerido',
    validate: {
      onlyNumbers: (value: string) => {
        const validation: boolean = onlyNumbers.test(value)
        return validation || 'El número solo debe contener números'
      },
    },
    maxLength: {
      value: 15,
      message: 'El teléfono no debe tener más de 15 caracteres',
    },
    minLength: {
      value: 5,
      message: 'El teléfono no debe tener menos de 5 caracteres',
    },
  },
}
